import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import Icon from '../../../../common/icons/Icon';
import ReduxFormInput from '../../../../common/forms/ReduxFormInput';
import formatClassDateRange from '../formatClassDateRange';

const validate = values => {
  const errors = {};
  const { message } = values;

  if (message.length > 255) {
    errors.message = 'Please limit your message to 255 characters or less.';
  }

  return errors;
};

class ClassRegistrationConfirmPurchaseForm extends Component {
  static propTypes = {
    ...formPropTypes,
    classEntity: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    school: PropTypes.object.isRequired,
    source: PropTypes.object.isRequired,
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  };

  render() {
    const { classEntity, handleSubmit, onCancel, school, source, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit} className="gs-page__modal__form">
        <div className="gs-page__modal__body class--confirm-purchase">
          <Icon icon="Money" />
          <h3 className="gs-page__modal__body--header">Confirm Purchase</h3>
          <p>You are purchasing a class at {school.name} scheduled for</p>
          <h3>{formatClassDateRange(classEntity.start_date, school.days)}</h3>
          <p>
            By confirming your purchase, your {source.get('brand')} ending in{' '}
            <strong className="last-four">{source.get('last4')}</strong> will be charged{' '}
            <strong>${(school.price / 100).toFixed(2)}</strong>
          </p>
        </div>
        <div className="gs-page__modal__body">
          <Field
            name="message"
            component={ReduxFormInput}
            label={`How far along in the 60-Day Training Program will you be upon your arrival for the golf school on ${formatClassDateRange(
              classEntity.start_date,
              school.days
            )}?`}
          >
            <textarea />
          </Field>
        </div>
        <div className="modal__actions">
          <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button type="submit" className="button" disabled={submitting}>
            Confirm Purchase
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'classRegistrationRequestForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(ClassRegistrationConfirmPurchaseForm);



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/class-registration/ClassRegistrationConfirmPurchaseForm.js